import React from "react";
import { Helmet } from "react-helmet";

const MadhyaPradeshSEO = () => {
  return (
    <Helmet>
      {/* 🟢 BASIC META */}
      <title>
        Buy Sex Toys in Madhya Pradesh | Discreet Delivery in Indore, Bhopal
      </title>

      <meta
        name="description"
        content="Buy sex toys online in Madhya Pradesh with 100% discreet delivery. Trusted adult store delivering to Indore, Bhopal, Jabalpur, Gwalior, Ujjain & more. Products for men, women & couples."
      />

      <meta
        name="keywords"
        content="sex toys in Madhya Pradesh, buy sex toys Indore, sex toys Bhopal, adult toys MP, couples sex toys Madhya Pradesh, adult store MP"
      />

      <meta name="robots" content="index, follow" />

      {/* 🟢 CANONICAL */}
      <link
        rel="canonical"
        href="https://lushdesire.in/sex-toys-delivery/madhya-pradesh"
      />

      {/* 🟢 OPEN GRAPH */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Buy Sex Toys in Madhya Pradesh | 100% Discreet Delivery"
      />
      <meta
        property="og:description"
        content="Order premium sex toys in Madhya Pradesh with fast & private delivery. Serving Indore, Bhopal, Jabalpur & more."
      />
      <meta
        property="og:url"
        content="https://lushdesire.in/sex-toys-delivery/madhya-pradesh"
      />
      <meta
        property="og:image"
        content="https://lushdesire.in/assets/og-madhya-pradesh.jpg"
      />

      {/* 🟢 TWITTER */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Sex Toys Delivery in Madhya Pradesh | LushDesire"
      />
      <meta
        name="twitter:description"
        content="Discreet sex toys delivery across Madhya Pradesh. Buy toys for men, women & couples online."
      />

      {/* 🟢 LOCAL SEO */}
      <meta name="geo.region" content="IN-MP" />
      <meta name="geo.placename" content="Madhya Pradesh" />
      <meta name="geo.position" content="23.2599;77.4126" />
      <meta name="ICBM" content="23.2599, 77.4126" />

      {/* 🟢 SCHEMA */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Store",
          "name": "LushDesire Madhya Pradesh",
          "url": "https://lushdesire.in/sex-toys-delivery/madhya-pradesh",
          "logo": "https://lushdesire.in/logo.png",
          "description": "Buy sex toys online in Madhya Pradesh with discreet packaging. Trusted adult store delivering across MP.",
          "areaServed": {
            "@type": "State",
            "name": "Madhya Pradesh"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "Madhya Pradesh",
            "addressCountry": "IN"
          },
          "sameAs": [
            "https://www.facebook.com/lushdesire",
            "https://www.instagram.com/lushdesire"
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default MadhyaPradeshSEO;
